export default "__VITE_ASSET__J$tQz1zc__"